import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 23px;
  padding-top: 4px;
  margin-bottom: 32px;
`;

export const SuccessModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 23px;
  padding-top: 32px;
  margin-bottom: 32px;
`;

export const Title = styled.h4`
  color: ${({ theme }) => theme.ui.colors.primary700};
  text-align: center;

  font-family: ${({ theme }) => theme.ui.fontFamilies.heading};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  margin: 0;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: #6b7280;
  text-align: center;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  margin: 0;
`;

export const FinalSubtitle = styled.p`
  color: ${({ theme }) => theme.ui.colors.primary700};
  text-align: center;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.26px;
  margin: 0;
  margin-top: 12px;
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding-bottom: 16px;
`;

export const QuestionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuestionLabel = styled.p`
  color: #111827;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`;

export const QuestionText = styled.p`
  color: #111827;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

export const ResponseLabel = styled.label`
  color: #111827;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`;

export const StyledTextarea = styled.textarea`
  border-radius: 8px;
  border: 1px solid #e5e7eb;

  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 137px;
  padding: 16px;

  outline: none;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  width: 100%;
  gap: 24px;
  margin: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  padding: 0 23px;
`;
